import { Box, Button } from "@mantine/core";
import { ExtensionData } from "../pages/Patient/PatientList";
import { getIntegrationTypes, platformLogo } from "../utils";

interface ButtonComponentProps {
  resource: any;
  userProfile?: any;
  handleLaunchClick: (
    e: React.MouseEvent<HTMLButtonElement>,
    resource: any
  ) => void;
  classes: any;
  hasTopLevelUrl: any;
}

export function ButtonComponent(props: ButtonComponentProps): JSX.Element {
  const { resource, userProfile, handleLaunchClick, classes, hasTopLevelUrl } =
    props;

  const integrationType = getIntegrationTypes(resource.meta.extension);
  const isConnected = hasTopLevelUrl(
    userProfile?.extension as ExtensionData[],
    `ClientApplication/${resource?.id}` || ""
  );
    const buttonText = isConnected ? "Disconnect" : "Connect";

  return (
    <Button
      variant="filled"
      onClick={(e) => handleLaunchClick(e, resource)}
      className={classes.launchButton}
      color={isConnected ? "#1B75BC" : "#1B75BC"}
    >
      {/* <Box
      // component="img"
      // src={
      //   platformLogo[integrationType[0]?.replace(/\s/g, "")?.toLowerCase()]
      // }
      // className={classes.platformLogo}
      /> */}
      {isConnected ? "Disconnect" : "Connect"}
    </Button>
  );
}
